import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { AppHeader } from "./header";
import { AppNavigation } from "./navigation";
import { componentRoutes } from "../routes/routes";
import { AppFooter } from "./footer";
import { getLocalStorage, setCounterInLocalStorage, getLoggedinUser, getUser, hasActionRights, setLocalStorage,hasActionRightsPracticePatient } from "../userStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isFullLayout } from "../utils/common_lib";
import { useIdleTimer } from "react-idle-timer";
import OTP from "../pages/auth/OTP";
import { logout } from "../userStore";
import { AppLogin } from "../pages/auth/login";
import PatientSwitch from "../pages/PatientSwitch";
import { useAppContext } from "../AppContext";
import { PatientDashboard } from "../pages/dashboard/dashboard";
import { authApi } from "../redux/service/authService";
import FullScreenLoader from "../components/FullScreenLoader";

export const AppMain = (props) => {
  const [availableRoutes, setAvailableRoutes] = useState("");
  //handle isLoggedIn user then redirect to dashboard,otherwise redirect to login
  const isLoggedIn = getLocalStorage("isLoggedIn");
  const localIsIdle = getLocalStorage("isIdle");
  const user = getLoggedinUser();
  const [selectedUser, setSelectedUser] = useState(null);
  const AppContext = useAppContext();
  const [patientPermission, setPatientPermission] = useState(null);
  const [loading, setLoading] = useState(true);
  let getUserFromLocalStorage = localStorage.getItem("session") || "";
   const [fetchPatientPermission,{isFetching}]= authApi.endpoints.getPatientPermissions.useLazyQuery();

  useEffect(() => {
    if (user&&isLoggedIn) {
      fetchPatientPermission({ user_id: user?.id })
        .unwrap()
        .then((res) => {
          setLocalStorage("patientPermission", res);
          setPatientPermission(res);
          setLoading(false);
        })
        .catch((err) => {
          console.log("error", err);
          setLoading(false);
        });
       
    }
  },[isLoggedIn,AppContext.AppData.selectedUser]);
  


  useEffect(() => {
    getUserFromLocalStorage = getUserFromLocalStorage ? JSON.parse(getUserFromLocalStorage) : "";
    const userInfo = AppContext.AppData.selectedUser || getUser() || getUserFromLocalStorage;
    setSelectedUser(userInfo);

    let allowedKeys = "settings";
    
    if (userInfo) {
      if (userInfo.is_patient === 1 || userInfo.is_patient === true) {
       
          const filtered = componentRoutes.filter((route) =>
            hasActionRights(route.slug, "view", userInfo)
          );
        
          if (filtered?.length) {
            allowedKeys += "," + filtered.map((route) => route.slug).join();
            allowedKeys += ",dashboard,create_pin";
          }else{
              allowedKeys += ",dashboard,create_pin";
          }
        
      }
      if (user.is_caregiver) {
        allowedKeys += ",patients,create_pin";
      }
    }
    setAvailableRoutes(allowedKeys);
  }, [AppContext.AppData.selectedUser, getUserFromLocalStorage,patientPermission]);

  const navigate = useNavigate();
  useEffect(() => {
    //if url is login and user is already logged in then redirect to dashboard, otherwise redirect to login
    if (isLoggedIn && window.location.pathname === "/login") {
      if (user?.pincode === "" && window.location.pathname !== "/create-pin") {
        navigate("/create-pin");
      } else {
        navigate("/dashboard");
      }
    }
    if (!isLoggedIn && window.location.pathname !== "/login") {
      navigate("/login");
    }
  }, [isLoggedIn]);

  //if user is not logged in, redirect to login page
  if (!isLoggedIn && window.location.pathname !== "/login") {
    navigate("/login");
  }

  if (
    user?.pincode === "" &&
    window.location.pathname !== "/create-pin" &&
    isLoggedIn
  ) {
    window.location.href = "/create-pin";
  }

  if (user?.pincode !== "" && window.location.pathname === "/create-pin") {
    // navigate("/dashboard");
    window.location.href = "/dashboard";
  }

  const fullLayoutCss = "";
  const navLayoutCss = "lg:pl-72 relative z-2";

  //on idle true set the idle state
  const [isIdle, setIsIdle] = useState(false);
  const handleOnIdle = () => {
    if (isLoggedIn) {
      setIsIdle(true);
      setLocalStorage("isIdle", true);
    }
  };
  const idleTime = process.env.REACT_APP_INITIAL_IDLE
    ? process.env.REACT_APP_INITIAL_IDLE
    : 10;
  const { reset } = useIdleTimer({
    timeout: 1000 * 60 * idleTime,
    onIdle: handleOnIdle,
  });

  const handleLogout = () => {
    if (isIdle) {
      handleReset();
      setLocalStorage("isIdle", false);
      logout();
    }
  };

  const logoutTime = process.env.REACT_APP_LOGOUT_TIMEOUT
    ? process.env.REACT_APP_LOGOUT_TIMEOUT
    : 40;

  useEffect(() => {
    let logoutTimer = null;
    if (isIdle) {
      logoutTimer = setTimeout(handleLogout, 1000 * 60 * logoutTime); // 5 more minutes after showing OTP

      return () => {
        clearTimeout(logoutTimer); //clear time
      };
    } else if (!isIdle && logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, [isIdle]);

  useEffect(() => {
    if (localIsIdle === true && isIdle === false && isLoggedIn) {
      setIsIdle(true);
    }
  }, [localIsIdle]);

  const handleReset = () => {
    setLocalStorage("isIdle", false);
    setIsIdle(false);
    reset();
    setCounterInLocalStorage(0);
  };

  const getLandingView = () => {
    if (selectedUser?.is_caregiver) {
      return <PatientSwitch />;
    }
    return <PatientDashboard />;
  };

    const filterNavLinks = r => {
       return (availableRoutes.includes('all') || availableRoutes.includes(r.slug));
    }

  return (
    <>
    {
      isFetching && (
        <div className="item-center">
          <div className="loader"><FullScreenLoader /></div>
        </div>
      )
    }
      {isLoggedIn && isIdle && (
        <div style={{ display: isIdle ? "block" : "none" }}>
          <OTP handleReset={handleReset} isIdle={isIdle} />
        </div>
      )}
      {(!isIdle || !isLoggedIn) && (
        <>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme="light"
          />
          <div
            className={`${
              (isLoggedIn && window.location.pathname !== "/create-pin") ||
              window.location.pathname === "/login"
                ? "bg-blue-600"
                : ""
            } fixed top-0 start-0 end-0 h-[270px]`}></div>
          <div className="">
            {!isFullLayout()  &&!isFetching&&(
              <AppNavigation availableRoutes={availableRoutes} />
            )}
            <div className={`${isFullLayout() ? fullLayoutCss : navLayoutCss}`}>
              {user && (
                <div className="sticky top-0 z-40 flex h-16 shrink-0 bg-blue-600/[.9] items-center gap-x-4 px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
                  <AppHeader />
                </div>
              )}
              <main className="pt-10">
                <div className="px-4 sm:px-6 lg:px-8">
                  <div
                    className={`border-b flex flex-col min-h-screen-c rounded-lg overflow-hidden bg-white ${
                      window.location.pathname === "/login" && "z-6 relative items-center justify-center"
                    }`}>
                    <Routes>
                      <Route path="/" element={getLandingView()} />
                      {(user&&!isFetching) ? (
                        componentRoutes.filter((r) => filterNavLinks(r)).map((r, rIndex) => (
                          <Route key={r.path + " - " + rIndex} path={r.path} element={r.element} />
                        ))
                      ) : (
                        <Route key="login" path="/login" element={<AppLogin />} />
                      )}
                    </Routes>
                  </div>
                </div>
              </main>
            </div>
          </div>
          <div className="app-footer footer-grd sticky bottom-0 z-4 w-full p-3 bg-white border-t border-grey-CF mt-auto">
            <AppFooter />
          </div>
        </>
      )}
    </>
  );
};
